module.exports = __webpack_public_path__ + "static/media/1080x642-mobile.2ad91492.jpg";